<template>
    <div id="status_dashboard">
        <div v-if="seeStatusDashboard">
            <template v-if="loading">
                <vx-card>
                    <h4 class="text-center">Loading Data.</h4>
                </vx-card>
            </template>
            <template v-else>
                <div>
                    <!-- charts  -->
                    <div class="space-btw-charts" v-if="$store.state.windowWidth <= 767">
                        <vs-row>
                            <vs-col vs-xs="6" vs-sm="6" vs-lg="3" class="mb-1 px-0 pr-3">
                                <SelectDate :selectedDate.sync="filters.from_date" label="Start Date" />
                                <small class="block text-danger mt-1" v-if="api_errors && api_errors.from_date">
                                    {{ api_errors.from_date.join(', ') }}
                                </small>
                            </vs-col>
                            <vs-col vs-xs="6" vs-sm="6" vs-lg="3" class="mb-1 px-0 pr-3 mobile_to_date">
                                <SelectDate :selectedDate.sync="filters.to_date" label="End Date" />
                                <small class="block text-danger mt-1" v-if="api_errors && api_errors.to_date">
                                    {{ api_errors.to_date.join(', ') }}
                                </small>
                            </vs-col>
                            <vs-col vs-xs="12" vs-sm="12" class="px-0 pr-3">
                                <InputSelect :model.sync="mobile_status_dashboard_filter" label="Module"
                                    placeholder="Choose" container_class="w-auto input-custom-dropdown"
                                    :options="mobile_status_dashboard_options" :multiple="false" 
                                />
                            </vs-col>
                        </vs-row>
                    </div>
                    <div v-else class="fix-filters mb-base">
                        <vx-card>
                            <vs-row>
                                <vs-col vs-xs="12" vs-sm="4" vs-lg="3" class="mb-3 px-0 pr-3">
                                    <SelectDate :selectedDate.sync="filters.from_date" label="Start Date" />
                                    <small class="block text-danger mt-1" v-if="api_errors && api_errors.from_date">
                                        {{ api_errors.from_date.join(', ') }}
                                    </small>
                                </vs-col>
                                <vs-col vs-xs="12" vs-sm="4" vs-lg="3" class="mb-3 px-0 pr-3">
                                    <SelectDate :selectedDate.sync="filters.to_date" label="End Date" />
                                    <small class="block text-danger mt-1" v-if="api_errors && api_errors.to_date">
                                        {{ api_errors.to_date.join(', ') }}
                                    </small>
                                </vs-col>
                            </vs-row>
                        </vx-card>
                    </div>
                    <div v-if="$store.state.windowWidth <= 767">
                        <div>
                            <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="px-0">
                                <h4 class="mb-4">Total Result: <span class="txt-color">{{ get_mobile_total_result_count(mobile_status_dashboard_filter) }}</span></h4>
                                <StatusDashboardIssueList @prev_data="prev_data" @next_data="next_data" :results="get_mobile_module_type_data(mobile_status_dashboard_filter)" 
                                    :prev_link="get_mobile_module_type_prev_link(mobile_status_dashboard_filter)" :next_link="get_mobile_module_type_next_link(mobile_status_dashboard_filter)" 
                                    :module_type="mobile_status_dashboard_filter ? mobile_status_dashboard_filter : '' " 
                                />
                            </vs-col>
                        </div>
                    </div>
                    <div v-else class="mt-2" style="width: 100%;">
                        <vs-tabs>
                            <!-- Routine Maintenance  -->
                            <vs-tab label="Routine Maintenance">
                                <div>
                                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3 px-0">
                                        <template v-if="routine_maintenance_data.length">
                                          <h4 class="mb-4">Total Result: <span class="txt-color">{{ routine_maintenance_count }}</span></h4>
                                            <StatusDashboardIssueList @prev_data="prev_data" @next_data="next_data" :results="routine_maintenance_data" 
                                            :prev_link="routine_maintenance_prev_link" :next_link="routine_maintenance_next_link" module_type="routine_maintenance" />
                                        </template>
                                        <h4 class="text-center" v-else>Data Not Available.</h4>
                                    </vs-col>
                                </div>
                            </vs-tab>
                            <!-- Electrical Maintenance  -->
                            <vs-tab label="Electrical Maintenance">
                                <div>
                                    <vs-row>
                                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                                            <template v-if="electrical_maintenance_data.length">
                                              <h4 class="mb-4">Total Result: <span class="txt-color">{{ electrical_maintenance_count }}</span></h4>
                                                <StatusDashboardIssueList @prev_data="prev_data" @next_data="next_data" :prev_link="electrical_maintenance_prev_link" 
                                                    :next_link="electrical_maintenance_next_link" :results="electrical_maintenance_data" module_type="electrical_maintenance" />
                                            </template>
                                            <h4 class="text-center" v-else>Data Not Available.</h4>
                                        </vs-col>
                                    </vs-row>
                                </div>
                            </vs-tab>
                            <!-- Major Maintenance -->
                            <vs-tab label="Major Maintenance">
                                <div>
                                    <vs-row>
                                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                                            <template v-if="major_maintenance_data.length">
                                              <h4 class="mb-4">Total Result: <span class="txt-color">{{ major_maintenance_count }}</span></h4>
                                                <StatusDashboardIssueList @prev_data="prev_data" @next_data="next_data" :prev_link="major_maintenance_prev_link" 
                                                    :next_link="major_maintenance_next_link" :results="major_maintenance_data" module_type="major_maintenance" />
                                            </template>
                                            <h4 class="text-center" v-else>Data Not Available.</h4>
                                        </vs-col>
                                    </vs-row>
                                </div>
                            </vs-tab>
                            <!-- Corrective Maintenance -->
                            <vs-tab label="Corrective Maintenance">
                                <div>
                                    <vs-row>
                                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                                            <template v-if="corrective_maintenance_data.length">
                                              <h4 class="mb-4">Total Result: <span class="txt-color">{{ corrective_maintenance_count }}</span></h4>
                                                <StatusDashboardIssueList @prev_data="prev_data" @next_data="next_data" :prev_link="corrective_maintenance_prev_link" 
                                                    :next_link="corrective_maintenance_next_link" :results="corrective_maintenance_data" module_type="corrective_maintenance" />
                                            </template>
                                            <h4 class="text-center" v-else>Data Not Available.</h4>
                                        </vs-col>
                                    </vs-row>
                                </div>
                            </vs-tab>
                            <!-- Road Incident -->
                            <vs-tab label="Road Incident">
                                <div>
                                    <vs-row>
                                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                                            <template v-if="road_incident_data.length">
                                              <h4 class="mb-4">Total Result: <span class="txt-color">{{ road_incident_count }}</span></h4>
                                                <StatusDashboardIssueList @prev_data="prev_data" @next_data="next_data" :prev_link="road_incident_prev_link" 
                                                    :next_link="road_incident_next_link" :results="road_incident_data" module_type="road_incident" />
                                            </template>
                                            <h4 class="text-center" v-else>Data Not Available.</h4>
                                        </vs-col>
                                    </vs-row>
                                </div>
                            </vs-tab>
                            <!-- Enroachment -->
                            <vs-tab label="Enroachment">
                                <div>
                                    <vs-row>
                                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                                            <template v-if="enroachment_data.length">
                                              <h4 class="mb-4">Total Result: <span class="txt-color">{{ enroachment_count }}</span></h4>
                                                <StatusDashboardIssueList @prev_data="prev_data" @next_data="next_data" :prev_link="enroachment_prev_link" :next_link="enroachment_next_link"
                                                    :results="enroachment_data" module_type="enroachment" />
                                            </template>
                                            <h4 class="text-center" v-else>Data Not Available.</h4>
                                        </vs-col>
                                    </vs-row>
                                </div>
                            </vs-tab>
                        </vs-tabs>
                    </div>
                </div>
            </template>
        </div>
        <div v-else>
            <PermissionDenied />
        </div>
    </div>
</template>

<script>
import SelectDate from '../components/letstream/ls-select-date/SelectDate.vue'
import moment from 'moment'
import { Request } from '../utils/requests'
import StatusDashboardIssueList from './charts/StatusDashboardIssueList.vue'

export default {
    components: {
        SelectDate,
        StatusDashboardIssueList
    },
    data() {
        let now = new Date();
        let current_year = now.getFullYear();

        return {

            api_errors: {},
            loading: false,

            filters: {
                from_date: moment(new Date(`${current_year}-01-01`)).format('YYYY-MM-DD'),
                to_date: moment(now).format('YYYY-MM-DD'),
            },

            routine_maintenance_prev_link: null,
            routine_maintenance_next_link: null,
            routine_maintenance_count: null,
            routine_maintenance_data: [],

            electrical_maintenance_prev_link: null,
            electrical_maintenance_next_link: null,
            electrical_maintenance_count: null,
            electrical_maintenance_data: [],

            major_maintenance_prev_link: null,
            major_maintenance_next_link: null,
            major_maintenance_count: null,
            major_maintenance_data: [],

            corrective_maintenance_prev_link: null,
            corrective_maintenance_next_link: null,
            corrective_maintenance_count: null,
            corrective_maintenance_data: [],

            road_incident_prev_link: null,
            road_incident_next_link: null,
            road_incident_count: null,
            road_incident_data: [],

            enroachment_prev_link: null,
            enroachment_next_link: null,
            enroachment_count: null,
            enroachment_data: [],

            mobile_status_dashboard_options: [
                { value: 'routine_maintenance', label: 'Routine Maintenance' },
                { value: 'electrical_maintenance', label: 'Electrical Maintenance' },
                { value: 'major_maintenance', label: 'Major Maintenance' },
                { value: 'corrective_maintenance', label: 'Corrective Maintenance' },
                { value: 'road_incident', label: 'Road Incident' },
                { value: 'enroachment', label: 'Enroachment Row' },
            ],

            mobile_status_dashboard_filter: null
        }
    },
    watch: {
        filters: {
            deep: true,
            handler(newV) {
                this.load_data();
            }
        },
    },
    computed: {
        seeStatusDashboard() {
            return this.hasAccess('read', 'status_dashboard', 'all')
        }
    },
    mounted() {
        if(window.innerWidth >= 1200) {
            this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', true)
            this.$store.commit('TOGGLE_REDUCE_BUTTON', true)
            this.$store.dispatch('updateSidebarWidth', 'reduced')
        }
        if (this.$store.state.is_online && this.seeStatusDashboard) {
            this.load_data()
        }
    },
    beforeDestroy(){
        if(window.innerWidth >= 1200) {
            this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', false)
            this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
            this.$store.dispatch('updateSidebarWidth', 'default')
        }
    },
    methods: {
        validating_filters() {

            if (!this.filters.from_date) {
                this.api_errors = {
                    "from_date": [
                        "Date from is required.",
                    ]
                }
                return true
            }

            if (!this.filters.to_date) {
                this.api_errors = {
                    "to_date": [
                        "Date to is required.",
                    ]
                }
                return true
            }

            if (this.filters.from_date > this.filters.to_date) {
                this.api_errors = {
                    "from_date": [
                        "should be less than to date.",
                    ]
                }
                return true
            }

            return false
        },
        load_data() {
            if (!this.validating_filters()) {
                this.load_routine_maintenance_data()
                this.load_electrical_maintenance_data()
                this.load_major_maintenance_data()
                this.load_corrective_maintenance_data()
                this.load_road_incident_data(),
                this.load_enroachment_data()
            }
        },
        load_routine_maintenance_data(link=null) {

            let url;
            let payload = {}

            if (link) {
                url = link
            } else {
                url = this.$store.state.apiendpoints.status_dashboard_data_issues

                payload = {
                    'from_date': this.filters.from_date,
                    'to_date': this.filters.to_date,
                    'module_type': 'routine_maintenance',
                    'resolution_status__in': 'p,null',
                }
            }

            payload['limit'] = 8

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.routine_maintenance_prev_link = res.previous
                    this.routine_maintenance_next_link = res.next
                    this.routine_maintenance_count = res.count
                    this.routine_maintenance_data = res.results
                    this.api_errors = {}
                },
                (err) => {
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Server error occured while loading issues. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        load_electrical_maintenance_data(link=null) {

            let url;
            let payload = {}

            if (link) {
                url = link
            } else {
                url = this.$store.state.apiendpoints.status_dashboard_data_issues
                
                payload = {
                    'from_date': this.filters.from_date,
                    'to_date': this.filters.to_date,
                    'module_type': 'electrical_maintenance',
                    'resolution_status__in': 'p,null'
                }

            }

            payload['limit'] = 8

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.electrical_maintenance_next_link = res.next
                    this.electrical_maintenance_prev_link = res.previous
                    this.electrical_maintenance_count = res.count
                    this.electrical_maintenance_data = res.results
                    this.api_errors = {}
                },
                (err) => {
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Server error occured while loading issues. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        load_major_maintenance_data(link=null) {

            let url;
            let payload = {}

            if (link) {
                url = link
            } else {
                url = this.$store.state.apiendpoints.status_dashboard_data_issues
                
                payload = {
                    'from_date': this.filters.from_date,
                    'to_date': this.filters.to_date,
                    'module_type': 'major_maintenance',
                    'resolution_status__in': 'p,null'
                }

            }

            payload['limit'] = 8

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.major_maintenance_next_link = res.next
                    this.major_maintenance_prev_link = res.previous
                    this.major_maintenance_count = res.count
                    this.major_maintenance_data = res.results
                    this.api_errors = {}
                },
                (err) => {
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Server error occured while loading issues. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        load_corrective_maintenance_data(link=null) {

            let url;
            let payload = {}

            if (link) {
                url = link
            } else {
                url = this.$store.state.apiendpoints.status_dashboard_data_issues
                
                payload = {
                    'from_date': this.filters.from_date,
                    'to_date': this.filters.to_date,
                    'module_type': 'highway',
                    'resolution_status__in': 'p,null'
                }

            }

            payload['limit'] = 8

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.corrective_maintenance_next_link = res.next
                    this.corrective_maintenance_prev_link = res.previous
                    this.corrective_maintenance_count = res.count
                    this.corrective_maintenance_data = res.results
                    this.api_errors = {}
                },
                (err) => {
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Server error occured while loading issues. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        load_road_incident_data(link=null) {

            let url;
            let payload = {}

            if (link) {
                url = link
            } else {
                url = this.$store.state.apiendpoints.status_dashboard_data_issues
                
                payload = {
                    'from_date': this.filters.from_date,
                    'to_date': this.filters.to_date,
                    'module_type': 'road_incident',
                    'resolution_status__in': 'p,null'
                }

            }

            payload['limit'] = 8

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.road_incident_next_link = res.next
                    this.road_incident_prev_link = res.previous
                    this.road_incident_count = res.count
                    this.road_incident_data = res.results
                    this.api_errors = {}
                },
                (err) => {
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Server error occured while loading issues. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        load_enroachment_data(link=null) {

            let url;
            let payload = {}

            if (link) {
                url = link
            } else {
                url = this.$store.state.apiendpoints.status_dashboard_data_issues
                
                payload = {
                    'from_date': this.filters.from_date,
                    'to_date': this.filters.to_date,
                    'module_type': 'enroachment_row',
                    'resolution_status__in': 'p,null'
                }

            }

            payload['limit'] = 8

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.enroachment_next_link = res.next
                    this.enroachment_prev_link = res.previous
                    this.enroachment_count = res.count
                    this.enroachment_data = res.results
                    this.api_errors = {}
                },
                (err) => {
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Server error occured while loading issues. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        next_data(module_type, link) {
            if (module_type=='routine_maintenance') {
                this.load_routine_maintenance_data(link);

            } else if (module_type=='electrical_maintenance') {
                this.load_electrical_maintenance_data(link);

            } else if (module_type=='major_maintenance') {
                this.load_major_maintenance_data(link);

            } else if (module_type=='corrective_maintenance') {
                this.load_corrective_maintenance_data(link);

            } else if (module_type=='road_incident') {
                this.load_road_incident_data(link);
                
            } else if (module_type=='enroachment') {
                this.load_enroachment_data(link);   
            }
        },
        prev_data(module_type, link) {
            if (module_type=='routine_maintenance') {
                this.load_routine_maintenance_data(link);

            } else if (module_type=='electrical_maintenance') {
                this.load_electrical_maintenance_data(link);

            } else if (module_type=='major_maintenance') {
                this.load_major_maintenance_data(link);

            } else if (module_type=='corrective_maintenance') {
                this.load_corrective_maintenance_data(link);

            } else if (module_type=='road_incident') {
                this.load_road_incident_data(link);
                
            } else if (module_type=='enroachment') {
                this.load_enroachment_data(link);   
            }
        },
        // mobile related methods 
        get_mobile_total_result_count(val) {
            if (val == 'routine_maintenance') {
                return this.routine_maintenance_count || 0

            } else if (val == 'electrical_maintenance') {
                return this.electrical_maintenance_count || 0

            } else if (val == 'major_maintenance') {
                return this.major_maintenance_count || 0

            } else if (val == 'corrective_maintenance') {
                return this.corrective_maintenance_count || 0

            } else if (val == 'road_incident') {
                return this.road_incident_count || 0

            } else if (val == 'enroachment') {
                return this.enroachment_count || 0

            } else {
                return 0
            }
        },
        get_mobile_module_type_data(val) {
            if (val == 'routine_maintenance') {
                return this.routine_maintenance_data

            } else if (val == 'electrical_maintenance') {
                return this.electrical_maintenance_data

            } else if (val == 'major_maintenance') {
                return this.major_maintenance_data

            } else if (val == 'corrective_maintenance') {
                return this.corrective_maintenance_data

            } else if (val == 'road_incident') {
                return this.road_incident_data

            } else if (val == 'enroachment') {
                return this.enroachment_data

            } else {
                return []
            }
        },
        get_mobile_module_type_prev_link(val) {
            if (val == 'routine_maintenance') {
                return this.routine_maintenance_prev_link

            } else if (val == 'electrical_maintenance') {
                return this.electrical_maintenance_prev_link

            } else if (val == 'major_maintenance') {
                return this.major_maintenance_prev_link

            } else if (val == 'corrective_maintenance') {
                return this.corrective_maintenance_prev_link

            } else if (val == 'road_incident') {
                return this.road_incident_prev_link

            } else if (val == 'enroachment') {
                return this.enroachment_prev_link

            } else {
                return null
            }
        },
        get_mobile_module_type_next_link(val) {
            if (val == 'routine_maintenance') {
                return this.routine_maintenance_next_link

            } else if (val == 'electrical_maintenance') {
                return this.electrical_maintenance_next_link

            } else if (val == 'major_maintenance') {
                return this.major_maintenance_next_link

            } else if (val == 'corrective_maintenance') {
                return this.corrective_maintenance_next_link

            } else if (val == 'road_incident') {
                return this.road_incident_next_link

            } else if (val == 'enroachment') {
                return this.enroachment_next_link

            } else {
                return null
            }
        }
    }
}
</script>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 768px) {
        @content;
    }
}
#status_dashboard {
    @include mobile {
        .space-btw-charts {
            margin-bottom: 2vh !important;
        }

        .mobile_to_date {
            .vdp-datepicker__calendar {
                margin-left: -40vw
            }
        }
    }

}
.vs--single .vs__selected {
  overflow: hidden !important;
  max-width: 19.8ch !important;
  white-space: nowrap !important;
}

.vs-tabs--ul {box-shadow:none;}
.vs-tabs-primary .line-vs-tabs {box-shadow:none !important;}
.vs-tabs--content {
  padding: 2px 10px !important;
}

.custombox .vs-con-loading__container {width:78% !important; margin: 0 auto !important;}

.col-cen .vs-table-text {text-align: center !important; display: block;}

.view-btn {background: #222 !important; color:#fff !important; padding: 8px 16px;
  border-radius: 0.75rem;}

.view-btn:hover { background: rgba(var(--vs-primary),1)!important;}

</style>
<style type="text/css" media="screen, projection">
@import url(https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.css);
</style>
